import React from 'react';

import format from 'date-fns/format';
import getDay from 'date-fns/getDay';

import styles from './styles.module.scss';

//https://date-fns.org/v2.25.0/docs/getDay
//Uwaga - numerowane 0-6, ale 0 to NIEDZIELA A NIE PONIEDZIALEK
//I oczywiscie po raz kolejny mamy problem  bo to nie iso ;)
const weekDaysCaption = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];

export default function WeekDayPicker({ data, changeFnc, isValid }) {
  let allChecked = true;
  data.forEach((option) => {
    if (!option.checked) {
      allChecked = false;
    }
  });

  const toggleAll = () => {
    changeFnc(
      data.map((day) => ({
        ...day,
        checked: !allChecked,
      })),
    );
  };

  const onChange = (id) => {
    changeFnc(
      data.map((day) => {
        let newChecked = day.checked;
        if (day.id === id) {
          newChecked = !newChecked;
        }

        return { ...day, checked: newChecked };
      }),
    );
  };

  const CheckboxInput = ({ onChange, checked, id, text }) => (
    <label className={styles.checkboxContainer} style={{ cursor: 'pointer' }}>
      <input
        className={styles.inputField}
        checked={checked}
        type="checkbox"
        onChange={() => onChange(id)}
      />
      <div className={styles.label}>{text}</div>
      <span className={styles.checkmark}></span>
    </label>
  );

  return (
    <>
      <div className={styles.checkboxsWrapper}>
        {data?.map((option, index) => (
          <CheckboxInput
            key={index}
            id={option.id}
            checked={option.checked}
            text={`${weekDaysCaption[getDay(option.date)]}, ${format(
              option.date,
              'dd.MM',
            )}`}
            onChange={onChange}
          />
        ))}
      </div>
      <div className={styles.buttonText} onClick={toggleAll}>
        {allChecked ? 'Odznacz wszystkie' : 'Zaznacz wszystkie'}
      </div>
      {!isValid && (
        <div className="FormField-validateText-container">
          <p className="FormField-validateText">
            Musi zostać wybrany conajmniej jeden dzień.
          </p>
        </div>
      )}
    </>
  );
}
